// eslint-disable-next-line prebid/validate-imports
import { MESSAGES } from '../../../src/constants.js';

export const MESSAGE_NATIVE = MESSAGES.NATIVE;
export const ACTION_RESIZE = 'resizeNativeHeight';
export const ACTION_CLICK = 'click';
export const ACTION_IMP = 'fireNativeImpressionTrackers';

export const ORTB_ASSETS = {
  title: 'text',
  data: 'value',
  img: 'url',
  video: 'vasttag'
}
